import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { getUserHeadMeta } from "@/helpers/user-meta";
import { fetchReviews } from "@/loaders/user-reviews";
import Reviews from "@/pages/user/reviews";

const searchSchema = z.object({
  sortBy: z.string().optional(),
});

export const Route = createFileRoute("/@{$username}/reviews/$category/")({
  component: ReviewsCategoryPage,
  head: ({ loaderData }) => {
    if (!loaderData) {
      return {};
    }
    return {
      meta: [
        ...getUserHeadMeta(loaderData.user, "reviews"),
        { content: "noindex", name: "robots" },
      ],
    };
  },
  loader: ({ params, search }) =>
    fetchReviews({
      data: {
        category: params.category,
        sortBy: search?.sortBy,
        username: params.username,
      },
    }),
  validateSearch: searchSchema,
});

function ReviewsCategoryPage() {
  const data = Route.useLoaderData();
  if (!data) {
    return null;
  }
  return <Reviews {...data} />;
}
